import { IAdminAuthUserResponseData, ILoginRequestPayload } from 'redux/reducers/auth/types';
import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TAuthApi } from './types';

// ==========================================:
export const auth: TAuthApi = {
	login: (payload) =>
		http
			.get<ILoginRequestPayload, { data: IAdminAuthUserResponseData }>(endpoint.auth.LOGIN, {
				params: payload,
			})
			.then((response) => response.data),
};
